/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchReadySource } from './MatchReadySource';
import {
    MatchReadySourceFromJSON,
    MatchReadySourceFromJSONTyped,
    MatchReadySourceToJSON,
    MatchReadySourceToJSONTyped,
} from './MatchReadySource';

/**
 * 
 * @export
 * @interface MatchTeamReadinessResponse
 */
export interface MatchTeamReadinessResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MatchTeamReadinessResponse
     */
    ready: boolean;
    /**
     * 
     * @type {MatchReadySource}
     * @memberof MatchTeamReadinessResponse
     */
    source?: MatchReadySource;
    /**
     * 
     * @type {number}
     * @memberof MatchTeamReadinessResponse
     */
    readyAt?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchTeamReadinessResponse
     */
    readyBy?: string;
}



/**
 * Check if a given object implements the MatchTeamReadinessResponse interface.
 */
export function instanceOfMatchTeamReadinessResponse(value: object): value is MatchTeamReadinessResponse {
    if (!('ready' in value) || value['ready'] === undefined) return false;
    return true;
}

export function MatchTeamReadinessResponseFromJSON(json: any): MatchTeamReadinessResponse {
    return MatchTeamReadinessResponseFromJSONTyped(json, false);
}

export function MatchTeamReadinessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchTeamReadinessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ready': json['ready'],
        'source': json['source'] == null ? undefined : MatchReadySourceFromJSON(json['source']),
        'readyAt': json['readyAt'] == null ? undefined : json['readyAt'],
        'readyBy': json['readyBy'] == null ? undefined : json['readyBy'],
    };
}

export function MatchTeamReadinessResponseToJSON(json: any): MatchTeamReadinessResponse {
    return MatchTeamReadinessResponseToJSONTyped(json, false);
}

export function MatchTeamReadinessResponseToJSONTyped(value?: MatchTeamReadinessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ready': value['ready'],
        'source': MatchReadySourceToJSON(value['source']),
        'readyAt': value['readyAt'],
        'readyBy': value['readyBy'],
    };
}

